import { css } from "@emotion/css"

export const prefix = "RebaseTable__"
export const getPrefixedClassNames = (...cns: string[]) =>
  cns.map((cn) => prefix + cn).join(" ")

export const styles = {
  container: css`
    --border-color: #e5e7eb;
    --active-color: #00b1a4;
    //
    --z-index-overlay: 60;
    --z-index-left: 50;
    --z-index-right: 40;
    //
    border: 1px solid var(--border-color);
    overflow: hidden;
    box-sizing: content-box;
    display: grid;
    width: 100%;
    background-color: rgb(241 241 241 / var(--a, 1));
    position: relative;
    height: var(--viewport-height);
    outline: none;
  `,

  scroller: css`
    height: var(--viewport-height);
    width: 100%;
    overflow: auto;
    ::-webkit-scrollbar {
      width: 12px;
      height: 12px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 6px;
    }
    display: grid;
    grid-template-columns: var(--container-template);
  `,

  dataGrid: css`
    height: var(--grid-height);
    pointer-events: var(--pointer-events, auto);
    &[data-area="fixed"] {
      position: sticky;
      left: 0;
      width: var(--fixed-data-grid-width);
      z-index: var(--z-index-left);
    }
    &[data-area="main"] {
      position: relative;
      width: var(--main-data-grid-width);
      z-index: var(--z-index-right);
    }
  `,

  row: css`
    background-color: #fff;
    display: grid;
    height: var(--row-height);
    position: absolute;
    top: 0;
    left: 0;
    &[data-area="fixed"] {
      grid-template-columns: var(--fixed-row-template);
      width: var(--fixed-row-width, 100%);
      min-width: var(--fixed-row-min-width, 0);
      z-index: calc(var(--z-index-left) + 1);
    }
    &[data-area="main"] {
      grid-template-columns: var(--main-row-template);
      width: var(--main-row-width, 100%);
      min-width: var(--main-row-min-width, 0);
      z-index: calc(var(--z-index-right) + 1);
    }
    &.locked {
      background-color: var(--light-grey);
    }
  `,
  locker: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vh;
    height: var(--row-height);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  `,
  header: css`
    background-color: #fff;
    height: var(--header-height);
    position: sticky;
    top: 0;
    left: 0;
    &[data-area="fixed"] {
      z-index: calc(var(--z-index-left) + 9);
    }
    &[data-area="main"] {
      z-index: calc(var(--z-index-right) + 9);
    }
  `,
  cell: css`
    position: relative;
    box-sizing: border-box;
    min-width: 0;
    display: flex;
    align-items: center;
    text-align: left;
    justify-content: flex-start;

    height: 100%;
    overflow: hidden;
    outline: none;

    border-bottom: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    background-color: inherit;
  `,
  headerCell: css`
    font-weight: 500;
    font-size: 0.75rem;
  `,
  bodyCell: css`
    font-size: 13px;
    :focus,
    :focus-within {
      box-shadow: inset 0px 0px 0px 2px var(--active-color);
    }
  `,
  hoverCell: css`
    background-color: var(--active-color);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    height: var(--height);
    top: var(--top);
    left: var(--left);
    width: 24px;
    transform: translate3d(-24px, 0px, 0px);
    border-radius: 2px 0px 0px 2px;
    will-change: transform, opacity;
    color: var(--white);
  `,
  cellText: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  //
  overlay: css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: var(--z-index-overlay);
    display: grid;
    place-items: center;
    font-size: 0.875rem;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
    background-color: rgba(255, 255, 255, 0.1);
  `,

  pending: css`
    backdrop-filter: blur(2px);
    z-index: calc(var(--z-index-overlay) + 1);
  `,

  empty: css``,

  aligns: {
    left: css`
      text-align: left;
      justify-content: flex-start;
    `,
    center: css`
      text-align: center;
      justify-content: center;
    `,
    right: css`
      text-align: right;
      justify-content: flex-end;
    `,
    spaceBetween: css`
      text-align: left;
      justify-content: space-between;
    `,
  },
}
